import { http_crm } from './HttpService.js'

export default {
	create(data) {
		return http_crm.post('interface/omie/entrypoint/general', data)
	},
	clients(uuid) {
		return http_crm.get('omie/clients/' + uuid)
	},
	contracts(uuid) {
		return http_crm.get('omie/contracts/' + uuid)
	},
	billing(ncontract) {
		return http_crm.get('omie/contracts/' + ncontract + '/fat')
	},
	invoice_fetching(cpf_cnpj) {
		return http_crm.get(`omie/finance/${cpf_cnpj}/fetch/EMABERTO`)
	}
}